import { offlineNetworkAction, onlineNetworkAction } from 'modules/network/actions'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import NProgress from 'nprogress'
import { createErrorUtil } from 'utils/error'
// import {
//   addLocationViewAction,
//   popLocationViewAction
// } from 'modules/views/actions'

function initProgressBar () {
  // Configure progress bar
  NProgress.configure({
    parent: '.app-loader',
    minimum: 0.4,
    showSpinner: false
  })
}

function initNetworkAction () {
  return (dispatch) => {
    /**
     * Triggered when the `window.navigator.onLine` changes.
     * Re-render the app, passing the `isOnline` props.
     */
    function onChangeNetwork () {
      const isOnline = !!window.navigator.onLine
      dispatch(
        isOnline
          ? onlineNetworkAction()
          : offlineNetworkAction()
      )
    }

    if (window.addEventListener) {
      window.addEventListener('online', onChangeNetwork)
      window.addEventListener('offline', onChangeNetwork)
    } else {
      window.attachEvent('online', onChangeNetwork)
      window.attachEvent('offline', onChangeNetwork)
    }
  }
}

function initErrorHandler () {
  return (dispatch, getState) => {
    window.onerror = (msg, url, lineNo, columnNo, error) => {
      const currentUser = getCurrentUserSelector()(getState())
      const data = createErrorUtil(error, currentUser, {
        message: msg
      })
      console.error('an error occurred: ', data)
    }
  }
}

function afterFirstNavigationHook () {
  return (dispatch) => {
    dispatch(
      initNetworkAction()
    )
    dispatch(
      initErrorHandler()
    )
    initProgressBar()
  }
}

export default afterFirstNavigationHook
